module.exports = __webpack_public_path__ + "static/Portrait-of-Benjamin-min-82e3f2ac2b5a8ede7c2b66645dd03a09.webp";